import { mdiChevronDown } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";
import Button from "components/Button";
import { IFactoringCompany } from "models/HaulPay";

type SelectFactoringCompanyProps = {
  selectedFactoringCompany?: IFactoringCompany;
  handleClickCompany: VoidFunction;
  handleClickNOA: VoidFunction;
  handleSubmitCompany: (company?: IFactoringCompany) => void;
};

export default function SelectFactoringCompany({
  selectedFactoringCompany,
  handleClickCompany,
  handleClickNOA,
  handleSubmitCompany
}: Readonly<SelectFactoringCompanyProps>) {
  return (
    <div className="flex flex-col flex-1 gap-4">
      <div className="flex gap-4 mobile:flex-col desktop:flex-none desktop:mx-auto">
        <button
          className="flex items-center justify-between h-12 p-4 rounded-lg bg-input desktop:w-3/4"
          onClick={handleClickCompany}>
          <span
            className={clsx({
              "text-placeholder": !selectedFactoringCompany
            })}>
            {selectedFactoringCompany
              ? selectedFactoringCompany.name
              : "Click here to select factoring company"}
          </span>
          <Icon path={mdiChevronDown} className="w-6" />
        </button>

        <Button
          type="button"
          rounded
          className="desktop:!w-64"
          onClick={() => handleSubmitCompany(selectedFactoringCompany)}>
          USE THIS FACTOR
        </Button>
      </div>

      <Button
        type="button"
        className="mt-auto desktop:!w-96 desktop:mx-auto"
        rounded
        onClick={handleClickNOA}>
        I ALREADY HAVE THE NOA
      </Button>
    </div>
  );
}
